import { connect, ConnectedProps } from 'react-redux'
import { AdminRoutesPaths } from '../../app/admin'
import { AllReduxAppPayloads, GlobalContext } from '../../utils/reducers'
import { Routes } from '../CreateRoutering/types'
import ModalAntiUnsave from '../ModalsLayouts/ModalAntiUnsave'
import ModalPopupMessage from '../ModalsLayouts/ModalPopupMessage'
import ModalRestrictTimeControlAccess from '../ModalsLayouts/ModalRestrictTimeControlAccess'
import Header, { HeaderAdminConnect } from './Header'
import Breadcrumb from './Header/Breadcrumb'
import RightSideHeader from './Header/RightSideHeader'
import LeftMenu from './LeftMenu'
import IconAdminMenuBar from './LeftMenu/AdminIconMenuBar'
import ModalBottomNavApp from '../ModalsLayouts/ModalBottomNavApp'
import TaskNotificationModal from '../../specificComponents/Task/TaskNotificationModal'
import { signOutUser } from '../../utils/reducers/reduxDispatch'
import { Link } from 'react-router-dom'
import TwinTrans from '../TwinTrans'
import NavigateArrows from './Header/NavigateArrows'
import { BookMarkRoute, BookMarkRoutesParsedTy } from '../../app/erp/types'

interface AppLayoutProps {
    routes: Routes
    children?: React.ReactNode
    bookMarkParsed: BookMarkRoute[]
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}

const AppLayout: React.FC<AppLayoutProps & ReduxAppLayoutConnector> = ({ children, routes, appStyle, bookMarkParsed, bookMarkParsedDict }) => {
    return (
        <AppLayoutBaseConnector>
            <LeftMenu routes={routes} appStyle={appStyle} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkParsedDict}/>
            <RightSideBase>
                <Header>
                    <NavigateArrows />
                    <Breadcrumb routes={routes} />
                    <RightSideHeader appStyle={appStyle} routes={routes} />
                </Header>
                {children}
            </RightSideBase>
        </AppLayoutBaseConnector>

    )
}

const mapAppLayoutConnector = (state: AllReduxAppPayloads) => ({ appStyle: state.user?.extraData?.Employee?.EmployeeParameters?.appStyle })
export const appLayoutConnector = connect(mapAppLayoutConnector, {}, null, { context: GlobalContext })
export type ReduxAppLayoutConnector = ConnectedProps<typeof appLayoutConnector>
const AppLayoutConnector = appLayoutConnector(AppLayout)

interface AppLayoutLoadedProps extends AppLayoutProps {}

export const AppLayoutLoaded: React.FC<AppLayoutLoadedProps> = ({ children, routes, bookMarkParsed, bookMarkParsedDict }) => {
    return (
        <AppLayoutConnector routes={routes} bookMarkParsed={bookMarkParsed} bookMarkParsedDict={bookMarkParsedDict}>
            {children}
            <ModalRestrictTimeControlAccess/>
            <TaskNotificationModal />
        </AppLayoutConnector>

    )
}
interface AppLayoutBaseProps extends ReduxAppBaseLayoutConnector {
    children: React.ReactNode
}

const AppLayoutBase: React.FC<AppLayoutBaseProps> = ({ children, dark_mode, appStyle }) => {
    return (
        <div className={'h-full w-full flex ' + (dark_mode === 'on' ? 'dark' : '') + ' ' + (appStyle !== 'default' ? 'appstyle_new1' : '')}>
            {children}
            <ModalPopupMessage />
            <ModalBottomNavApp />
            <ModalAntiUnsave />
        </div>
    )
}

const mapAppLayoutBaseConnector = (state: AllReduxAppPayloads) => ({ dark_mode: state.user?.extraData?.Employee?.EmployeeParameters?.dark_mode, showBubbleInnerTabs: state.user?.extraData?.Employee?.EmployeeParameters?.showBubbleInnerTabs, appStyle: state.user?.extraData?.Employee?.EmployeeParameters?.appStyle })
export const appLayoutBaseConnector = connect(mapAppLayoutBaseConnector, {}, null, { context: GlobalContext })
export type ReduxAppBaseLayoutConnector = ConnectedProps<typeof appLayoutBaseConnector>
const AppLayoutBaseConnector = appLayoutBaseConnector(AppLayoutBase)

interface RightSideBaseProps {
    children: React.ReactNode
}

const RightSideBase: React.FC<RightSideBaseProps> = ({children}) => {
    return (
        <div className='flex flex-col flex-auto bg-gray-F7 app_right_side w-1'>
            {children}
        </div>
    )
}

interface AppLayoutAdminProps {
    children: React.ReactNode
}

export const AppLayoutAdmin: React.FC<AppLayoutAdminProps> = ({ children }) => {
    const routes = AdminRoutesPaths()
    return (
        <AppLayoutBase showBubbleInnerTabs='off' dark_mode='off' appStyle='default'>
            <IconAdminMenuBar routes={routes} />
            <RightSideBase>
                <HeaderAdminConnect routes={routes}/>
                {children}
            </RightSideBase>
        </AppLayoutBase>
    )
}

interface AppLayoutWithOutMenuProps {
    routes: Routes
    children?: React.ReactNode
}

export const AppLayoutWithoutMenu: React.FC<AppLayoutWithOutMenuProps> = ({ children, routes }) => {
    return (
        <AppLayoutBaseConnector>
            <div className='flex flex-col flex-auto bg-gray-F7 app_right_side w-1'>
                <Header>
                    <NavigateArrows />
                    <Breadcrumb routes={routes} />
                    <RightSideHeader routes={routes} />
                </Header>
                {children}
                <Link to='/' onClick={signOutUser} className='block text-center text-green-21 mt-auto pb-60'><TwinTrans transKey='signOut'>Cerrar sesión</TwinTrans></Link>
            </div>
        </AppLayoutBaseConnector>
    )
}

export default AppLayout